import {mirrorWindsorReportCurrentRequest,type MirrorWindsorReportRequest} from '../../supabase/functions/_shared/mirrorWindsorReportIntent';
const uuid = (value: unknown): value is string => typeof value === 'string' && /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/iu.test(value);
const object = (value: unknown): value is Record<string, unknown> => !!value && typeof value === 'object' && !Array.isArray(value);
export interface MirrorWindsorReportOrigin {
  ownerId: string;
  sessionId: string;
  authSessionId: string;
  actionId: string;
  args: MirrorWindsorReportRequest;
  isCurrent: () => boolean;
}
export function prepareMirrorWindsorReportOrigin(options: {
  ownerId: string; sessionId: string; authSessionId: string | null; latestUserText: string;
  proposals: unknown[]; actionResults: unknown[]; finalSessionId: string | null; finalMessageId: string | null;
  isCurrent: () => boolean;
}): MirrorWindsorReportOrigin | null {
  const requested = mirrorWindsorReportCurrentRequest(options.latestUserText);
  if (!requested || !uuid(options.ownerId) || !uuid(options.sessionId) || !uuid(options.authSessionId)
    || options.finalSessionId !== options.sessionId || options.proposals.length !== 1
    || options.actionResults.length !== 0 || !options.isCurrent()) return null;
  const proposal = options.proposals[0];
  if (!object(proposal) || Object.keys(proposal).sort().join(',') !== 'action_id,args,preview,tool'
    || proposal.tool !== 'windsor_report_request' || !uuid(proposal.action_id)
    || proposal.action_id !== options.finalMessageId || typeof proposal.preview !== 'string' || !proposal.preview
    || !object(proposal.args) || Object.keys(proposal.args).sort().join(',') !== 'action,provider,raw_text'
    || proposal.args.provider !== 'windsor' || proposal.args.action !== 'report_request'
    || proposal.args.raw_text !== requested.raw_text) return null;
  return {ownerId:options.ownerId,sessionId:options.sessionId,authSessionId:options.authSessionId,
    actionId:proposal.action_id,args:requested,isCurrent:options.isCurrent};
}
